import React from 'react';
import { useSelector } from "react-redux";
import './VendorSubscription.css';
import { capitalizeWords } from '../../../Utils/LetterCase';
function VendorSubscription() {
    const { data } = useSelector((state) => state.fetchProfileData);

    return (
        <div className="community-section">
            <div className="community-inner-wrapper d-flex align-items-center justify-content-between">
                <div className="add-new-community d-flex justify-content-between align-items-center mb-0">
                    <div className="community-heading">Subscriptions</div>
                </div>
                <div className='category-block'>
                    <b>Category: {capitalizeWords(data?.data?.sub_vendor_type)}</b>
                </div>
            </div>
            <div className="all-commmunities-table">
                <div className='billing-box'>
                    <div className='billing-title allcommunities'>
                        Add Subscription
                    </div>
                    <div className='billing-subboxes vendorsubs'>
                        <div className='billing-innerwrap d-flex align-items-center justify-content-between'>
                            <div className='billing-left-block d-flex align-items-center gap-2'> <div className='add-icon'><i className="fa fa-plus" aria-hidden="true"></i></div>Vendor Directory Listing</div>
                        </div>
                    </div>
                    <div className='billing-subboxes vendorsubs'>
                        <div className='billing-innerwrap d-flex align-items-center justify-content-between'>
                            <div className='billing-left-block d-flex align-items-center gap-2'> <div className='add-icon'><i className="fa fa-plus" aria-hidden="true"></i></div>Advertisement Banner</div>
                        </div>
                    </div>
                </div>
                <div className='payments-table reports vendorad'>
                    <table className="table">
                        <thead>
                            <tr>
                                <th scope="col">City</th>
                                <th scope="col">Type</th>
                                <th scope="col">Price</th>
                                <th scope="col">Banner</th>
                                <th scope="col"></th>
                            </tr>
                        </thead>
                        <tbody className="table-group-divider">
                            <tr>
                                <td>Jupiter FL</td>
                                <td>Directory Listing</td>
                                <td>$9.76</td>
                                <td><div><button className='btn-submit-claim default'>Default</button></div></td>
                                <td><div><button className='btn-submit-claim unsubscribe'>Unsubscribe</button></div></td>
                            </tr>
                            <tr>
                                <td>Jupiter FL</td>
                                <td>Ad Banner</td>
                                <td>$9.76</td>
                                <td><div><button className='btn-submit-claim default'>Default</button></div></td>
                                <td><div><button className='btn-submit-claim unsubscribe'>Unsubscribe</button></div></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className='tabs-lower-block'>
                    <div className='tabs-inner-wrap'>
                        <div className='cityname-input mb-4'>
                            <input type="text" placeholder="Search by City Name..." />
                        </div>
                        <div className='table-lower-block'>
                            <div className='table-inner-block'>
                                <table className="table">
                                    <tbody>
                                        <tr>
                                            <td>Miami FL</td>
                                            <td>Directory Listing</td>
                                            <td><b><span>$</span>9.95</b></td>
                                            <td><div className='subscribe-btn'><button className='btn-submit-claim unsubscribe'>Unsubscribe</button></div></td>
                                        </tr>
                                        <tr>
                                            <td>Miami Beach FL</td>
                                            <td>Directory Listing</td>
                                            <td><b><span>$</span>9.95</b></td>
                                            <td><div className='sold-out'>SOLD OUT</div></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default VendorSubscription;